import { render, staticRenderFns } from "./PubDatesChecker.vue?vue&type=template&id=d494d65a&"
import script from "./PubDatesChecker.vue?vue&type=script&lang=js&"
export * from "./PubDatesChecker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports